export default __webpack_public_path__ + "static/media/knowledge.1127292b.svg";